import InputSlider from "./vueComponents/InputSlider.vue";
import { createApp } from 'vue';

export default {
    name: 'finance',
    _el: null,

    init() {
        this._el = document.getElementById('js_finance');

        if (this._el) {
            this.run();
        }
    },

    run()
    {
         const app = createApp({

            delimiters: ['@{', '}'],

            data()  {
                return {
                    status          : 'ready',
                    orgPrice        : 0,
                    price           : 0,
                    years           : 10,
                    interest        : 5.45,
                    capital         : 0,
                    isToggled       : false
                }
            },

            created()
            {
                this.init();
            },

            computed :
            {
                monthlyPrice(){
                    const loan = this.price-this.capital;
                    let remainingLoan = loan;
                    const monthlyPrices = [];

                    // beregn månedlige kostnader ift antall år
                    for (let i=this.years; i>0; i--) {
                        let yearlyLoan      = remainingLoan/i; // årets avdrag
                        let yearlyInterest  = remainingLoan*this.interest/100; // årets rente

                        let yearlyPayback   = yearlyInterest + yearlyLoan; // årets kotandaner
                        let monthlyPrice    = parseInt(yearlyPayback / 12); // årets månedlige kostnader
                        monthlyPrices.push(monthlyPrice);

                        remainingLoan = remainingLoan - yearlyLoan; // gjenstående lån
                    }

                    // beregn gjenommsnittlig pris per måned
                    const average = monthlyPrices.reduce((total, sum) => total + sum)/monthlyPrices.length;

                    return parseInt(average);
                }
            },

            methods:
            {
                nok (v) {
                    let value = parseInt(v);

                    if (!Number.isInteger(value)) {
                        return null;
                    }

                    return  value === 0 ? '' :'kr. ' + value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
                },

                percent (v) {
                    let value = parseInt(v);

                    if (!Number.isInteger(value)) {
                        return null;
                    }

                    const price = document.getElementById('js_theProduct').dataset.price;

                    return ' (' + Math.round((value/price) * 100) + '%)';
                },

                init() {
                    const el = document.getElementById('js_theProduct');

                    if (el) {
                        this.orgPrice = document.getElementById('js_theProduct').dataset.price;
                        this.price = this.orgPrice;
                        this.capital = parseInt(this.price*0.3);
                    }
                },

                setYears(years) {
                    this.years = parseInt(years);
                },

                setPrice(price) {
                    this.price = parseInt(price);
                },

                setInterest(interest) {
                    this.interest = parseFloat(interest);
                },

                setCapital(capital) {
                    this.capital = parseInt(capital);
                },

                toggle() {
                    this.isToggled = !this.isToggled;
                }

            }
        });

        app.component('input-slider', InputSlider); // Global registration
        app.mount('#js_finance');

    }
}